import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

export interface AssignAssociatedClientPromptDialogData {
  title?: string;
  message?: string;
  confirmText?: string;
  dismissText?: string;
}

@Component({
  selector: "app-assign-associated-client-prompt-dialog",
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="p-6">
      <div class="flex flex-col items-center gap-4">
        <div
          class="flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 dark:bg-amber-900/40"
        >
          <i class="pi pi-building text-4xl text-amber-700 dark:text-amber-300"></i>
        </div>
        <div class="text-center">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
            {{ data.title || "Cliente asociado" }}
          </h3>
          <p class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
            {{ data.message || defaultMessage }}
          </p>
        </div>
        <div class="flex flex-col sm:flex-row gap-3 mt-2 w-full">
          <button
            type="button"
            (click)="onConfirm()"
            class="w-full px-4 py-2 bg-primary hover:bg-primary-900 text-white rounded-md text-sm font-semibold transition cursor-pointer"
          >
            <i class="pi pi-arrow-right mr-2"></i>
            {{ data.confirmText || "Ir a asignación" }}
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class AssignAssociatedClientPromptDialogComponent {
  protected readonly dialogRef = inject(DynamicDialogRef);
  protected readonly config = inject(DynamicDialogConfig<AssignAssociatedClientPromptDialogData>);
  protected readonly data = this.config.data ?? {};

  readonly defaultMessage =
    "Como agente de aduana debe asignar o confirmar el cliente asociado con el que operará en el portal. " +
    "Debe hacerlo ahora en la pantalla de clientes asociados.";

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
